import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";

function CombinationsPage(props: any) {
  const { filters, formDefaultValues, withCards } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters, true, true);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const { detailsFunction } = useDetailsAction(0);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction, // We pass the function to initialize a new element (used in the create button)
        indexFunction, // We pass the function to index the table
        getFunction, // We pass the function to get an element (used in the edit button)
        prepareRemoveFunction,
        detailsFunction,
        /**newActionsTableConfig**/
      }),
    [
      initializeFunction,
      indexFunction,
      getFunction,
      prepareRemoveFunction,
      detailsFunction,
    ]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <Card.Title>{t("other_combinations")}</Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </div>

      <div className="mt-3">
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </div>
    </div>
  );
}

export default CombinationsPage;
